const processInclude = require('./util');
const dataLayer = require('./dataLayer/dataLayer');

$(document).ready(() => {
    processInclude(require('./components/forms/Spinbutton'));
    processInclude(require('./cart/cart'));
    processInclude(require('./cart/editLineItem'));
    processInclude(require('./cart/promoCodeForm'));
    processInclude(require('./cart/removeCoupon'));
    processInclude(require('./cart/changeQty'));
    processInclude(require('./cart/selectShippingMethod'));
    processInclude(require('./cart/proceedToCheckout'));
    processInclude(dataLayer.cart);
});
